/* eslint react/jsx-no-duplicate-props: 0 */
import TextFieldValidation from '@components/TextFieldValidation/TextFieldValidation';
import EditIcon from '@mui/icons-material/Edit';
import { InputAdornment } from '@mui/material';
import { TypographyOptions } from '@mui/material/styles/createTypography';
import { useTheme } from '@mui/system';
import React from 'react';
import { ITheme } from 'types/theme';

interface FlowBuilderEditableTitleProps {
	formik: any;
	autoFocus?: boolean;
}

const FlowBuilderEditableTitle = ({
	formik,
	autoFocus
}: FlowBuilderEditableTitleProps) => {
	const theme = useTheme<ITheme>();

	return (
		<TextFieldValidation
			formik={formik}
			name="name"
			id="name"
			autoFocus={autoFocus}
			sx={{
				border: 0,
				'.MuiFormHelperText-root': {
					position: 'absolute',
					bottom: -17,
					left: 0,
					margin: 0
				}
			}}
			inputProps={{
				'data-testid': 'flow-editable-title',
				'aria-label': 'flow-editable-title'
			}}
			InputProps={{
				sx: {
					...(theme.typography as TypographyOptions).h6!,
					height: '40px',
					'&:hover, &:active': { '.title-edit-icon': { visibility: 'visible' } }
				},
				endAdornment: (
					<InputAdornment position="end">
						<EditIcon
							className="title-edit-icon"
							sx={{
								visibility: 'hidden',
								color: theme.palette.text.disabled
							}}
						/>
					</InputAdornment>
				)
			}}
		/>
	);
};

FlowBuilderEditableTitle.defaultProps = {
	autoFocus: false
};

export default FlowBuilderEditableTitle;
